export const UPDATE_NEIGHBORHOOD = "UPDATE_NEIGHBORHOOD";

export const updateNeighborhood = (neighborhoods) => ({
	type: UPDATE_NEIGHBORHOOD,
	neighborhoods
})




// WEBPACK FOOTER //
// ./lib/actions/filter_actions.js